export const TAX_REFUND_ERROR = {
  홈택스패스워드오류: 'ERR_HOMETAX_PASSWORD',
  홈택스이용불가계정: 'ERR_HOMETAX_BLOCK_ID',
  홈택스법인계정아님: 'ERR_HOMETAX_NO_CORPS_ID',
  홈택스주민ID아님: 'ERR_HOMETAX_NO_JUMIN_ID',
  홈택스이용불가시간: 'ERR_HOMETAX_IMPOSSIBLE',
  홈택스점검중: 'ERR_HOMETAX_SERVER_FIX',
  홈택스수집오류: 'ERR_HOMETAX_COLLECT',
  홈택스계산오류: 'ERR_HOMETAX_CALCULATE',
  홈택스세션오류: 'ERR_HOMETAX_SESSION',
  홈택스입력오류: 'ERR_HOMETAX_INPUT',
  중복신청: 'ERR_DUPLICATE_APPLY',
  람다메시지BYPASS: 'ERR_LAMBDA_MESSAGE_BYPASS',
  홈택스만료된인증서: 'ERR_HOMETAX_EXPIRE_CERT',
  홈택스등록되지않은인증서: 'ERR_HOMETAX_NO_REGIST_CERT',
  중복조회: 'ERR_EXIST_SEARCH_HISTORY',
  홈택스회원아님: 'ERR_HOMETAX_NO_USER',
  홈택스사업자없음: 'ERR_HOMETAX_NO_BMAN',
  홈택스간편인증오류: 'ERR_HOMETAX_SIMPLE_AUTH',
  홈택스타임아웃: 'ERR_HOMETAX_TIMEOUT',
  기존TIN과불일치: 'ERR_NO_EQUAL_TIN',
  환급완료유저TIN: 'ERR_EXIST_FINISH_REFUND',
  연말정산없음: 'ERR_NOT_EXIST_YEAR_END_TAX_SETTLEMENT',
  기타오류: 'ERR_ETC',
  리턴즈미조회: 'ERR_NOT_EXIST_RETURNS',
  환급미조회: 'ERR_NOT_EXIST_HISTORY',
  홈택스기타오류: 'ERR_HOMETAX_ETC',
  유효시간만료된URL: 'ERR_EXPIRE_URL'
} as const;

export const CARD_PAYMENT_ERROR: Record<string, { title: string; description: string }> = {
  ERR_CARD_NUMBER: {
    title: '카드번호를 다시 입력해주세요',
    description: '입력하신 카드번호가 정확하지 않아요. 다시 확인해주세요.'
  },
  ERR_CARD_EXPIRED: {
    title: '유효기간을 다시 입력해주세요',
    description: '입력하신 카드 유효기간이 정확하지 않아요. 다시 확인해주세요.'
  },
  ERR_CARD_PASSWORD: {
    title: '카드 비밀번호를 다시 입력해주세요',
    description: '입력하신 카드 비밀번호가 일치하지 않아요. 5회 오류 시 해당 카드 등록이 어려워요.'
  },
  ERR_CARD_PASSWORD_FIVE_TIMES: {
    title: '카드 비밀번호 오류 횟수를 초과해 사용이 제한됐어요',
    description: '해당 카드사 문의를 통해 카드 제한을 해제해주시거나, 다른 카드를 입력해주세요.'
  },
  ERR_CARD_BIRTH: {
    title: '생년월일을 다시 입력해주세요',
    description: '입력하신 생년월일이 정확하지 않아요. 다시 확인해주세요.'
  },
  ERR_HECTO_ETC: {
    title: '입력 정보를 다시 확인해주세요',
    description: '입력하신 카드번호에 대한 입력 정보가 정확한지 확인해주세요. 같은 문제가 반복되는 경우 문의해주세요.'
  }
};
